import React, { Component } from 'react'

const getFirstLine = (address) => {
  let str = []
  if (address.streetName) {
    str.push(address.streetName)
    if (address.streetNumber) {
      str.push(' ')
      str.push(address.streetNumber)
    }
    if (address.level) {
      str.push(', ')
      str.push(address.level)
    }
  }
  return str.join('')
}

const getSecondLine = (address) => {
  let str = []
  if (address.postalCode || address.postalArea) {
    str.push(address.postalCode)
    if (address.postalCode && address.postalArea) {
      str.push(' ')
    }
    str.push(address.postalArea)
  }
  return str.join('')
}

class Address extends Component {

  getInline = () => {
    const address = this.props.address
    const firstLine = getFirstLine(address)
    const secondLine = getSecondLine(address)
    let str = []
    if (firstLine.length > 0) {
      str.push(firstLine)
    }
    if (secondLine.length > 0) {
      if (firstLine.length > 0) {
        str.push(', ')
      }
      str.push(secondLine)
    }
    if (str.length > 0) {
    	return (
        <span className='Address'>{str.join('')}</span>
      )
    } else {
      return null
    }
  }

  getBlock = () => {
    const address = this.props.address
    const firstLine = getFirstLine(address)
    const secondLine = getSecondLine(address)
    if (firstLine.length > 0 || secondLine.length > 0) {
      return (
        <div className='Address'>
          {firstLine}<br />
          {secondLine}
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    const {
      inline = false
    } = this.props
    if (inline) {
      return this.getInline()
    } else {
      return this.getBlock()
    }
  }

}

export default Address



// WEBPACK FOOTER //
// ./src/components/Address/Address.js